import { assertValidVersion } from "@tsparticles/engine";
import { Collider } from "./Collider.js";
export async function loadParticlesCollisionsInteraction(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addInteractor("particlesCollisions", container => {
        return Promise.resolve(new Collider(container));
    }, refresh);
}
